package nl.volleyplanner.web.base

fun String.toCssSelector(): String {
    if (this.isEmpty()) return "_empty"

    return this
        .replace(Regex("[^a-zA-Z0-9_-]"), "_") // Replace invalid chars with underscore
        .let { sanitized ->
            // Ensure doesn't start with digit or dash
            when {
                sanitized.isEmpty() -> "_empty"
                sanitized.first().isDigit() || sanitized.first() == '-' -> "_$sanitized"
                else -> sanitized
            }
        }
}
